import React from 'react';
import { Card, Tabs, Typography } from 'antd';
import { ScheduleTab } from './ScheduleTab';
import { SettingsTab } from './SettingsTab';

/**
 * Daily Challenge (Challenger Mode): one batting scenario per IST day, a
 * 7-day streak with Day 3 / Day 7 crates. Players see it only while the
 * feature.challenger switch is on (Configuration → feature flags).
 */
export const DailyChallengePage: React.FC = () => (
  <Card
    title="Daily Challenge"
    extra={
      <Typography.Text type="secondary">
        Shown to players only while feature.challenger is on
      </Typography.Text>
    }
  >
    <Tabs
      items={[
        { key: 'schedule', label: 'Schedule', children: <ScheduleTab /> },
        { key: 'settings', label: 'Streak & rewards', children: <SettingsTab /> },
      ]}
    />
  </Card>
);
